var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(1 1)"},[React.createElement("circle",{"cx":"16","cy":"16","r":"16.5","fill":"#000","fillOpacity":".4","stroke":"#FFF","key":0}),React.createElement("path",{"fill":"#FFF","fillRule":"nonzero","d":"M22.7 9.3c-.4-.4-1-.4-1.4 0L16 14.6l-5.3-5.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l5.3 5.3-5.3 5.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3l5.3-5.3 5.3 5.3c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4L17.4 16l5.3-5.3c.4-.4.4-1 0-1.4z","key":1})]));
}

Close.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34"};

module.exports = Close;

Close.default = Close;
